import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/store';
import { MdAddBox } from "react-icons/md";

import { Question, questionTypesArray, Scale, ShortResponse, Survey, YesNo } from '../types';
import TextField from '../Components/TextField';
import Modal from './Modal';
import { addSurveyQuestion, updateSurveyQuestion } from '../Firebase/utils';
import { addQuestion, updateQuestion } from '../store/features/CreateSurveySlice';

interface YesNoFormProps {
    question?: Question;
    openState: boolean;
    onClose: (result?: any) => void;
}

const ScaleForm: React.FC<YesNoFormProps> = (props: YesNoFormProps) => {

    const { openState, onClose } = props;

    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const dispatch = useAppDispatch();
    const [question, setQuestion] = useState<Question>(props.question ||{
        id: uuidv4(),
        questionText: '',
        type: 'YesNo',
        questionBody: {
            options: ['Yes', 'No']
        } as YesNo
    });

    const handleDelete = async () => {
        try{
            console.log('Deleting...');
            await addSurveyQuestion(user, survey, question);
            dispatch(addQuestion({question, response: { questionId: question.id, questionText:question.questionText, questionType:question.type, results:[] }}));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleUpdate = async () => {
        try{
            console.log('Updating...');
            await updateSurveyQuestion(user, survey, question);
            dispatch(updateQuestion(question));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleSubmit = () => {
        if(question.questionText === ''){
            alert('Question cannot be empty');
            return;
        }
        if(props.question){
            handleUpdate();
        }else{
            handleDelete();
        }
    };

    return (
        <Modal title='Yes or No Form' styles='gap-4' openState={openState} onClose={() => { onClose(undefined) }}>
            <div className='flex flex-col gap-6 md:gap-10'>
                <TextField placeholder={'Question'} inputValue={question.questionText} setInputValue={(e) => setQuestion({ ...question, questionText: e })} />
                <button onClick={() => { handleSubmit() }} className='w-full bg-[#3da8e2] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>{props.question ? 'Update Question' : 'Add Question'}</button>
            </div>
        </Modal>
    )

}

export default ScaleForm;